import React from 'react'

import { Field } from 'formik'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import Input from 'components/Forms/FormElements/Input'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'

const EventFormTitleModule = ({ label }) => {
    return (
        <EventFormModule className="event-form-title-module">
            <CompactFormRow
                iconName="exclamation-circle"
                label={label}
                trackName="title"
            >
                <Field
                    type="text"
                    name="title"
                    placeholder=""
                    size="s"
                    label=""
                    component={Input}
                />
            </CompactFormRow>
        </EventFormModule>
    )
}

export default EventFormTitleModule
